// v2 answers come back as two strings: a 1-2 sentence direct_answer and a
// body_markdown with additional context. We render them joined as the
// assistant bubble's content. Direct answer goes first, separated from the
// body by a blank line.
export function composeAnswer(directAnswer, bodyMarkdown) {
  const direct = String(directAnswer || '').trim();
  const body = String(bodyMarkdown || '').trim();
  if (!direct && !body) return '';
  if (!direct) return body;
  if (!body) return direct;
  return `${direct}\n\n${body}`;
}

// Normalize a v2 citation ({ source_id, locator, supporting_quote, source_title,
// authority, audience, url }) into the shape the existing CitationList renders
// (title/speaker/timestamp/citation_key).
export function normalizeV2Citation(c) {
  if (!c || typeof c !== 'object') return c;
  return {
    ...c,
    title: c.source_title || c.title || c.source_id,
    speaker: c.speaker || '',
    timestamp: c.timestamp || c.locator || '',
    citation_key: c.citation_key || `${c.source_id || 'source'}:${c.locator || ''}`,
  };
}
